import React, { useEffect, useState } from "react"
import { ArrowLeftFromLine, ArrowRightFromLine } from "lucide-react"
import { useAppCtx } from 'lib/state';
import { cn, randoms } from 'lib/utils';
import { stashDragPayload } from 'lib/utils/dragstore';


export default function CollectionLoader({ 
  title="Loader",
  collection, 
  selectFn, 
  selectProp="_id", 
  labelProp="name",
  showDescriptions=false,
  markSelected=null,
  draggable=false,
  expanded=true,
  toggleExpanded=() => {},
  Icon,
  className="",
  innerClassName=""
}:{ 
  title?:string
  collection:any[]
  selectFn?:Function 
  selectProp?:string
  labelProp?:string 
  showDescriptions?:boolean
  markSelected?:any
  draggable?:boolean
  expanded?:boolean
  toggleExpanded?:any
  Icon?:any
  className?:string
  innerClassName?:string
  [key:string]: any
}){

  // useEffect(() => {
  //   console.log(collection)
  // },[collection])

  const [ active, setActive ] = useState<string|undefined>()
  const [ description, setDescription ] = useState<string|undefined>()
  const [ itemInView, setItemInView ] = useState<any>(undefined)

  const chooseItem = (item:any) => {
    if( selectFn !== undefined ){
      selectFn(item)
    }
  }

  const handleItemClick = (item:any) => {
    setActive(item[selectProp])
    if( showDescriptions ){
      setItemInView(item)
      if( item.description !== undefined ){
        if( !item.description.length ){
          setDescription("No description available")
        } else {
          setDescription(item.description)
        }
      }
    } else {
      chooseItem(item)
    }
  }

  if( !expanded ) {
    return (
      <div className="std-block-title h-8 flex justify-center items-center">
        <ArrowRightFromLine className="size-4 cursor-pointer" onClick={toggleExpanded} />
      </div>
    )
  }

  useEffect(() => {
    console.log(collection?.length)
  },[collection])

  return (
    <div className={cn("w-full h-full flex flex-col", className)}>
      { title !== "[none]" && (
        <div className="std-block-title h-8 justify-between mb-0">
          <span>{title}</span>
          { expanded !== undefined && (
            <div className="w-6 h-6 flex justify-center items-center">
              <ArrowLeftFromLine className="size-4 cursor-pointer" onClick={toggleExpanded} />
            </div>
          )}
        </div>
      )}

      { expanded === true && collection?.length > 0 && (
        <div className={cn("w-full flex flex-col", innerClassName)}>
          { collection.sort((a:any, b:any) => a[labelProp] > b[labelProp] ? 1: -1).map( (item:any) => (
            <div 
              key={item[selectProp]} 
              onClick={() => handleItemClick(item)}
              className={cn(
                "w-full flex flex-col items-start justify-start pl-2 pr-5 py-1 text-xs uppercase cursor-pointer hover:bg-slate-800/50 break-words",
                markSelected !== null && markSelected(item) === true && "bg-teal-900 hover:bg-teal-900",
                markSelected === null && item[selectProp] === active && "bg-teal-900 hover:bg-teal-900",
              )}
              draggable={ draggable }
              onDragStart={ (e:any) => {
                if( draggable ){
                  const payload = JSON.stringify({...item, from: "loader"})
                  console.log(payload.length)
                  if( item.stash === true || payload.length > 1700 ){
                    console.log("stashing...")
                    const uniqueid = randoms.string(15, "a#")
                    stashDragPayload(uniqueid, {...item, from: "loader"})
                    e.dataTransfer.setData("text/plain", JSON.stringify({stashed: uniqueid}))
                  } else {
                    e.dataTransfer.setData("text/plain", JSON.stringify({...item, from: "loader"}))
                  }
                }
              }}
            >
              <span className="pl-1">{item[labelProp]}</span>
              { showDescriptions && itemInView?._id === item._id && itemInView !== undefined && (
                <div className="w-full mt-1 flex flex-col text-xs text-neutral-500/70">
                  <span className="normal-case text-xs px-1 italic text-white">{ itemInView.description || "No description available" }</span>
                  { draggable !== true && (
                    <span 
                      onClick={() => chooseItem(item)}
                      className="w-[94%] mx-auto mt-2 flex justify-center items-center text-white text-xs px-2 py-[2px] border border-solid border-white/50"
                    >
                      choose this item
                    </span>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}